import { useState } from 'react';
import HookForm from '../../../../components/HookForm/HookForm';
import Button from '../../../../components/Button/Button';
import { MASK } from '../../../../constants/mask';

/**
 * Данные владельца комиссионного авто (Freedom, п.4.1 схемы v5).
 *
 * Для типов THRIFT* банк не пропустит подтверждение перерегистрации, пока не
 * получит владельца: он сверяет ИИН с базой МВД по VIN и шлёт владельцу СМС
 * для согласия на продажу. Порядок обязателен: сначала owner, затем
 * re-register/confirm.
 *
 * [sent] — владелец уже отправлен (appeal.ownerSentAt заполнен). Тогда вместо
 * формы показываем статус, смену номера и кнопку перезапуска проверки:
 * перезапуск нужен после хука OWNER_ON_REVISION, когда менеджер обновил
 * данные владельца в ЦОН.
 */
const FreedomOwnerInfo = ({ onSubmit, onChangePhone, onRestart, loading, sent, revisionReason }) => {
  const [phoneFormOpen, setPhoneFormOpen] = useState(false);

  if (sent) {
    return (
      <div style={{ marginBottom: 20 }}>
        <HookForm title={'Владелец авто'} grid={{ display: 'grid', gap: 20 }} inputs={[]} onSubmit={() => {}} />
        <p style={{ marginTop: -10, marginBottom: 12 }}>
          {revisionReason
            ? `Банк вернул данные владельца на доработку: ${revisionReason}`
            : 'Данные владельца отправлены в банк. Владельцу направлено СМС для согласия на продажу.'}
        </p>

        {/*
          Смена номера (п.4.2 схемы) — на случай, когда владелец продиктовал
          неверный номер и СМС не дошла. Банк принимает PATCH только до начала
          проверки владельца; если уже поздно — вернёт понятную ошибку.
          Перезапуск проверки этот случай не лечит: он не меняет номер.
        */}
        {phoneFormOpen ? (
          <HookForm
            grid={{ display: 'grid', gap: 20 }}
            action={'Изменить номер'}
            inputs={[
              {
                label: 'Новый номер телефона владельца',
                name: 'mobilePhone',
                type: 'phone',
                mask: MASK.PHONE,
                inputMode: 'numeric',
                rules: {
                  required: true,
                  validate: (value) => (value || '').replace(/\D/g, '').length === 11,
                },
              },
            ]}
            onSubmit={(values) => {
              onChangePhone(values);
              setPhoneFormOpen(false);
            }}
            loading={loading}
            // HookForm вызывает backHandler() во время рендера и рендерит
            // результат как JSX — сюда нужен элемент, а не обработчик.
            backHandler={() => (
              <Button
                type={'button'}
                text={'Отмена'}
                onClick={() => setPhoneFormOpen(false)}
                style={{ color: '#BABABA', border: '1px solid #BABABA' }}
              />
            )}
          />
        ) : (
          // Обе кнопки — равнозначные действия менеджера, поэтому одинаковый
          // вид и общая ширина: серый контур читался как «недоступно».
          // type="button" обязателен: Button без type рендерит <button> без
          // атрибута, а такая кнопка внутри формы считается submit — клик
          // уходил в сабмит формы вместо onClick, и кнопка «не нажималась».
          <div style={{ display: 'grid', gap: 10, justifyItems: 'start' }}>
            <Button
              type={'button'}
              text={'Изменить номер владельца'}
              onClick={() => setPhoneFormOpen(true)}
              style={{ color: 'rgb(73, 65, 54)', border: '1px solid rgb(73, 65, 54)', width: 320 }}
            />
            <Button
              type={'button'}
              text={'Перезапустить проверку владельца'}
              onClick={onRestart}
              disabled={loading}
              style={{ color: 'rgb(73, 65, 54)', border: '1px solid rgb(73, 65, 54)', width: 320 }}
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{ marginBottom: 20 }}>
      <HookForm
        title={'Владелец авто'}
        subtitle={() => (
          <p style={{ marginBottom: 10 }}>
            Комиссионное авто: банк требует данные текущего владельца до подтверждения перерегистрации. Владельцу придёт
            СМС для согласия на продажу.
          </p>
        )}
        grid={{ display: 'grid', gap: 20 }}
        action={'Отправить в банк'}
        inputs={[
          {
            label: 'ИИН владельца',
            name: 'iin',
            mask: MASK.IIN,
            inputMode: 'numeric',
            rules: {
              required: true,
              validate: (value) => (value || '').replace(/\D/g, '').length === 12,
            },
          },
          {
            label: 'Номер телефона владельца',
            name: 'mobilePhone',
            type: 'phone',
            mask: MASK.PHONE,
            inputMode: 'numeric',
            rules: {
              required: true,
              validate: (value) => (value || '').replace(/\D/g, '').length === 11,
            },
          },
        ]}
        onSubmit={onSubmit}
        loading={loading}
      />
    </div>
  );
};

export default FreedomOwnerInfo;
